const cancellers = new Set<() => void>();

export function registerPendingDesignDraftSave(cancel: () => void): () => void {
  cancellers.add(cancel);
  return () => {
    cancellers.delete(cancel);
  };
}

export function cancelPendingDesignDraftSaves(): void {
  cancellers.forEach((c) => {
    try {
      c();
    } catch (err) {
      console.warn('cancelPendingDesignDraftSaves: canceller threw', err);
    }
  });
}
